import OrdersContainer from 'shared/components/OrdersDashboard/components/Container';
import { PHYSICAL_ORDERS_CONFIG, OrdersDashboardContext } from 'shared/components/OrdersDashboard/config';
import { usePageViewEvent, useFiltersChangeEvent } from 'shared/gtm/hooks';

function PhysicalOrders() {
  usePageViewEvent();
  useFiltersChangeEvent();

  return (
    <OrdersDashboardContext.Provider value={PHYSICAL_ORDERS_CONFIG}>
      <OrdersContainer />
    </OrdersDashboardContext.Provider>
  );
}

export default PhysicalOrders;
